module.exports = __webpack_public_path__ + "assets/img/25_342.5bc353cd.jpg";